import { memo } from "react"

const ImpactHistory = () => {
  return (
    <>
      Không có dữ liệu
    </>
  )
}

export default memo(ImpactHistory)